import Box from "@mui/material/Box";
import { Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const MenuNotch = () => {
  const theme = useTheme();

  return (
    <Stack
      sx={{
        position: "relative",
        bottom: 1,
        width: "100%",
        borderRadius: 12,
      }}
      direction={"row"}
      spacing={0}
    >
      <Box
        sx={{
          flex: 1,
          backgroundColor: theme.palette.grey[300],
          height: 50,
          borderBottomLeftRadius: 12,
          position: "relative",
          "&::after": {
            content: '""',
            position: "absolute",
            right: -1,
            top: 0,
            width: 2,
            height: "100%",
            backgroundColor: theme.palette.grey[300],
          },
        }}
      />

      <Box
        sx={{
          width: 251,
          flexShrink: 0,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <svg
          width="251"
          height="50"
          viewBox="0 0 201 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            display: "block",
            position: "relative",
          }}
        >
          <path
            d="M64.7463 38.7974C61.2165 45.4038 54.8806 50.4639 47.3904 50.4639H-87V0H100.5H288V50.4639H153.861C146.251 50.4639 139.86 45.2348 136.269 38.5264C129.393 25.6851 117.802 17.4639 100.5 17.4639C83.0769 17.4639 71.6905 25.8009 64.7463 38.7974Z"
            fill={theme.palette.grey[300]}
          />
        </svg>
      </Box>

      <Box
        sx={{
          flex: 1,
          backgroundColor: theme.palette.grey[300],
          height: 50,
          borderBottomRightRadius: 12,
          position: "relative",
          "&::before": {
            content: '""',
            position: "absolute",
            left: -1,
            top: 0,
            width: 2,
            height: "100%",
            backgroundColor: theme.palette.grey[300],
          },
        }}
      />
    </Stack>
  );
};

export default MenuNotch;
